<template>
    <list-widget title="주문회원" max-width="200" #default="{ attrs }">
        <autocomplete-member v-model="query['_member']" v-bind="attrs" placeholder="전체" dense flat solo hide-details clearable @input="emit" />
    </list-widget>
</template>

<script>
import AutocompleteMember from "../../dumb/autocompletes/autocomplete-member.vue";
import ListWidget from "../../dumb/list/list-widget.vue";

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["_member"]: query?.["_member"] || null,
});

export default {
    components: {
        AutocompleteMember,
        ListWidget,
    },
    data: () => ({
        query: initQuery(),
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["_member"]) delete query["_member"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
